import {
  CLEAR_ACCOUNT_SEARCH,
  SEARCH_ACCOUNTS,
  SEARCH_ACCOUNTS_FAILURE,
  SEARCH_ACCOUNTS_SUCCESS,
} from '../actions'
import { INITIAL_ACCOUNT_SEARCH_STATE } from '../containers/contexts/search'
import { Account, AccountSearchState } from '../types'

export const accountsReducer = (
  state: AccountSearchState = INITIAL_ACCOUNT_SEARCH_STATE,
  action: {
    type: string
    accountResults?: Account[]
    errorMessage?: string
    searchTerm?: string
  }
): AccountSearchState => {
  const { type, accountResults = [], errorMessage, searchTerm = '' } = action
  switch (type) {
    case SEARCH_ACCOUNTS:
      return {
        ...state,
        ...INITIAL_ACCOUNT_SEARCH_STATE,
        loadingResults: true,
        searchTerm,
      }
    case SEARCH_ACCOUNTS_SUCCESS:
      return { ...state, accountResults, loadingResults: false }
    case SEARCH_ACCOUNTS_FAILURE:
      return { ...state, loadingResults: false, errorMessage }
    case CLEAR_ACCOUNT_SEARCH:
      return { ...state, ...INITIAL_ACCOUNT_SEARCH_STATE }
    default:
      return state
  }
}
